import {FaLeaf} from "react-icons/fa";
import {Header} from "../components/Header";

const NatureWarriors = () => {
    const englishTitles = [
        // {
        //     title: "Foreword",
        //     link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/amit-chandra.pdf"
        // },
        {
            title: "7 Ways to Increase your Income through Precision Farming",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/ameya-moksadar.pdf"
        },
        {
            title: "Sustainability through Circular Economy",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/anand-rajkumar-chordia.pdf"
        },
        {
            title: "Beneficial Insects",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/deepak-pundlik.pdf"
        },
        {
            title: "Now or Never!",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dipti-kommera.pdf"
        },
        {
            title: "Agriculture and the Role of Engineers in its Development",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-arun-p-kulkarni.pdf"
        },
        {
            title: "The Ideas and Knowledge of Economically Poor People are Important for the Sustainable Farming",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/padmashri-anil-gupta.pdf"
        },
        {
            title: "Seven Chamber Story",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-pravin-chordia.pdf"
        },
        {
            title: "Bringing People Together to do Vishwa Kalyan",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/vinayak-chhatre.pdf"
        },
        {
            title: "S4S Technologies, Mumbai",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/vaibhav-tikdke.pdf"
        },
        {
            title: "Rural Relations",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/pradit-lokhande.pdf"
        },
        {
            title: "Pani Panchyat",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/pb-shitole.pdf"
        },
        {
            title: "Yogeshwar Krishi (Farms of God)",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/pandurangshashtri-aathhvale-and-family.pdf"
        },
        {
            title: "My Smart Millets",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/krishna-kanthawala.pdf"
        },
        {
            title: "Special Interest Group for Affordable Agriculture (SIGAA)",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/jagdish-chaudhari.pdf"
        },
        {
            title: "Kisan - Agriculture Robot",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/ieee-mit-group-1.pdf"
        },
        {
            title: "Taste-wise Fruit Sorting System using Thermal Image Processing",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/ieee-mit-group-2.pdf"
        },
        {
            title: "Real Time Cloud Sensing",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/ieee-mit-group-3.pdf"
        },
        {
            title: "Smart Greenhouse",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/ieee-mit-group-4.pdf"
        },
        {
            title: "Smart Fish Farm Monitoring System",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/ieee-mit-group-5.pdf"
        },
        {
            title: `Rishi Samskruti Vidya Kendra's (RSVK) Inspirational Leadership Rural Development (ILRD) Programme`,
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/guruji-rishi-prabhakar.pdf"
        },
        {
            title: "Opportunities in Exotic Vegetables Product Choice + Production Method + Marketing Strategy",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/gouri-jadhav.pdf"
        },
        {
            title: "Jivad - The Organic Way",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-vandana-shiva.pdf"
        },
        {
            title: "Wealth Creation Centre",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/rajubhai-gandhi.pdf"
        },
    ];

    const marathiTitles = [
        {
            title: "कणेरी मठ, कोल्हापूर",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/adrushya-kad-siddheshwar-swamiji.pdf"
        },
        {
            title: "मातीविरहित शेती स्ट्रॉबेरी शेती ",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/anil-kisan-dudhane.pdf"
        },
        {
            title: "शेती आधारित व्यवसायासाठी शिक्षण",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/amit-makhare.pdf"
        },
        {
            title: "सोला(र)पूरची प्रयोगशाळा एक नैसर्गिक प्रयोगशील अभियंता",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/arun-deshpande.pdf"
        },
        {
            title: "सेंद्रिय शेती, पारनेर",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/deepak-narvade.pdf"
        },
        {
            title: "कशी करावी - परवडणारी शेती",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/diliprao-deshmukh-baradkar.pdf"
        },
        {
            title: "त्याज्य शेतमालापासून पेट्रोलियमला पर्याय",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-anand-karve-1.pdf"
        },
        {
            title: "शाश्वत विकासासाठी महिला संघटनाची गरज..",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-anjali-ramchandra-kadam-narayane.pdf"
        },
        {
            title: "मातीतल्या खनिजांचे वनस्पतींद्वारे ग्रहण",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-anand-karve.pdf"
        },
        {
            title: "शाश्वत कृषी व्यवसायाला दिशा देणारे कृषी विज्ञान केंद्र, बाभळेश्वर",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-bhaskar-gaikwad.pdf"
        },
        {
            title: "ऊस शेतीचे गणित",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-gurudas-nulkar.pdf"
        },
        {
            title: "औषधी, सुगंधी वनस्पती",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-priyanka-adhikarao-adate.pdf"
        },
        {
            title: "हवामानबदलानुसार पीकपद्धतीत व व्यवस्थापनात बदल",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-ramchandra-sabale.pdf"
        },
        {
            title: "विक्रीव्यवस्थेची जोड दिल्याशिवाय शेती व्यवसाय नफ्यात चालू शकत नाही",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/gyaneshwar-bodke.pdf"
        },
        {
            title: "स्वयंपूर्ण गाव राजुरी : दररोज २० लाखांचे उत्पन्न",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/vinaykumar-aawate.pdf"
        },
        {
            title: "सह्याद्री : शेतीतील समूह शक्तीचा अविष्कार!",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/vilas-shinde.pdf"
        },
        {
            title: "एस व्ही पी ग्रुप ऑफ कंपनीज्",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/vikas-dangat.pdf"
        },
        {
            title: "भाऊ इन्स्टिट्यूट",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/vijay-talele.pdf"
        },
        {
            title: "प्रयोगशील महिला शेतकरी मुलाखत",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/uma-kshirsagar.pdf"
        },
        {
            title: "स्वप्नभूमी — शेती कोणी करायची?",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/suryakant-kulkarni.pdf"
        },
        {
            title: "झिरो बजेट' शेतीचा संकल्प",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/subhash-palekar.pdf"
        },
        {
            title: "प्रयोगशील शेतकरी यशोगाथा",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/shivajirao-ramrao-deshmukh.pdf"
        },
        {
            title: "शेतकरी उत्पादक कंपनी - अर्थात Farmer Producer Organization (FPO)",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/sanjay-pandhare.pdf"
        },
        {
            title: "सप्तश्रृंगी फार्मर प्रोड्युसर कंपनी टीसीएस- एम कृषीप्रणाली",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/sandeep-javle-and-roshan-jadhav.pdf"
        },
        {
            title: "शेतातील काडीकचऱ्यापासून बहुपयोगी नूतनक्षम कोळसा",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/priyadarshini-karve.pdf"
        },
        {
            title: "हापूस आंब्याची लागवड.... शाश्वत शेती",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/prashant-vinayak-kulkarni.pdf"
        },
        {
            title: "माती, पाणी व शरीराच्या विश्रांतीसाठी हिवरे बाजारचे शेतकरी सुट्टीवर",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/popatrao-pawar.pdf"
        },
        {
            title: "चितळ्यांची शेती",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/padmaja-parshuram-chitale.pdf"
        },
        {
            title: "सुजलाम् सुफलाम् देश",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/manohar-khake.pdf"
        },
        {
            title: "मॉफ - सेंद्रीय चळवळ आणि भावी दिशा",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/madhav-pandit.pdf"
        },
        {
            title: "'पवित्रक' अंजीराची मॉलमध्ये विक्री",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/krushiratna-engineer-sameer-dombepatil.pdf"
        },
        {
            title: "शेतकरी आणि पर्यावरण",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/ketaki-ghate.pdf"
        },
        {
            title: "वाफसा",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/kalpana-dudhhal.pdf"
        },
        {
            title: "सेंद्रिय शेती - आमचा सहभाग",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/jayant-waman-barve.pdf"
        },
        {
            title: "भारत विकास निर्माण ग्रुप",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/hanmantrao-ramdas-gaikwad.pdf"
        },
        {
            title: "आम्ही पण सायंटिस्ट व इनोव्हेटर, पाबळ विज्ञान आश्रम",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-yogesh-kulkarni.pdf"
        },
        {
            title: "हवामान बदलाचा शिल्पकार : आपण स्वतः",
            link: "https://jogkulstorageuat.blob.core.windows.net/siteassets/nature-warriors/dr-vinita-apte.pdf"
        }
    ];

    const renderList = (data) =>
        data.map((item, index) => (
            <li key={index}>
                <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-gradient-to-r from-green-50 to-green-100
                        border border-green-200 rounded-xl p-4
                        flex items-center space-x-4 hover:shadow-lg
                        transition-shadow duration-300"
                >
                    <FaLeaf
                        className="text-green-500 flex-shrink-0"
                        size={24}
                    />
                    <p
                        className={`text-green-900 font-medium text-lg
                            leading-snug break-words font-custom-semi-bold`}
                        title={item.title}
                    >
                        {item.title}
                    </p>
                </a>
            </li>
        ));

    return (
        <div className="w-full bg-white rounded-lg flex flex-col items-center justify-center">
            <Header/>

            <div
                className={`min-w-screen max-w-screen 
                    bg-slate-50 min-h-screen max-h-screen
                    grid grid-cols-1 md:grid-cols-3
                    portrait:pt-[4rem] portrait:sm:pt-[5.5rem] portrait:jk:pt-[5rem]
                    landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]
                    portrait:pb-[0.75rem] landscape:pb-[0.5rem]
                    pl-[0.75rem] pr-[0.4rem] gap-[0.75rem]`}
            >
                {/* Tree Plantation Banner */}
                <section className="bg-white rounded-2xl shadow-lg p-4 aspect-square">
                    <img
                        src="/banners/tree-plantation-banner.jpg"
                        alt="Tree Plantation"
                        className="w-full aspect-square rounded-xl"
                    />
                </section>

                <section
                    className="flex flex-col bg-white rounded-3xl shadow-lg
                        p-8 max-h-full landscape:overflow-hidden"
                >
                    <h2
                        className={`text-3xl font-bold mb-6 text-green-700
                            text-center tracking-wide font-custom-bold`}
                    >
                        English Articles on Nature
                    </h2>
                    <ul className="space-y-5 landscape:overflow-y-auto">
                        {renderList(englishTitles)}
                    </ul>
                </section>

                <section
                    className="flex flex-col bg-white rounded-3xl shadow-lg
                        p-8 max-h-full landscape:overflow-hidden"
                >
                    <h2
                        className={`text-3xl font-bold mb-6 text-green-700
                            text-center tracking-wide font-custom-bold`}
                    >
                        Marathi Articles on Nature
                    </h2>
                    <ul className="space-y-5 landscape:overflow-y-auto">
                        {renderList(marathiTitles)}
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default NatureWarriors;
